
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sentry_sample_error",
      function () {
        return require("private-next-pages/sentry_sample_error.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sentry_sample_error"])
      });
    }
  